/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of UniqueH5EnvConfig
 */

import { ITrackerContext } from 'com/didichuxing/tracker/context/ITrackerContext';
import { ITracker } from 'com/didichuxing/tracker/ITracker';
import AH5EnvConfigSync from 'com/didichuxing/tracker/h5/envconfig/AH5EnvConfigSync';
import UUID from 'com/didichuxing/tracker/plugin/utils/UUID';

const OMEGA_ID: string = '_OMGID';

export default class UniqueH5EnvConfig extends AH5EnvConfigSync {

    private context: ITrackerContext | undefined;

    /**
     * @override
     * @inheritDoc
     * @param {ITrackerContext} context
     * @returns {boolean}
     */
    public validate(context: ITrackerContext): boolean {
        this.context = context;
        return !!context.unique;
    }

    /**
     * 从cookie中读取omgid
     * @returns {string | undefined}
     */
    private getOmgIdFromCookie(): string | undefined {
        const items: string[] = document.cookie.split(';');
        for (let i: number = 0, j: number = items.length; i < j; ++i) {
            if (items[i].trim().indexOf(`${ OMEGA_ID }=`) === 0) {
                return items[i].split('=')[1].trim();
            }
        }
        return;
    }

    // /**
    //  * @override
    //  * @inheritDoc
    //  * @returns {Promise<void>}
    //  */
    // public beforeDeliver(tracker: ITracker): Promise<void> {
    //     return new Promise<void>((resolve: () => void): void => {
    //         if (this.context) {
    //             let omgId: string | undefined = this.context.omgId || this.getOmgIdFromCookie();
    //             if (omgId) {
    //                 Object.assign(this.context, {
    //                     omgId: omgId
    //                 });
    //                 resolve();
    //             } else {
    //                 const setOpenIdHandler: (openid: string) => void = tracker.setOpenId;
    //                 tracker.setOpenId = (openid: string): void => {
    //                     setOpenIdHandler.call(tracker, openid);
    //                     if (openid) {
    //                         omgId = openid;
    //                         const expiredDate: Date = new Date();
    //                         expiredDate.setFullYear(expiredDate.getFullYear() + 10);
    //                         document.cookie = `${ OMEGA_ID }=${ omgId }; expires=${ expiredDate }; path=/`;
    //                         Object.assign(this.context, {
    //                             omgId: omgId
    //                         });
    //                         resolve();
    //                     }
    //                 };
    //             }
    //         }
    //     });
    // }

    /**
     * @override
     * @inheritDoc
     * @returns {Promise<void>}
     */
    public beforeDeliver(tracker: ITracker): Promise<void> {
        if (this.context) {
            let omgId = this.context.omgId || this.getOmgIdFromCookie();
            if (!omgId) {
                omgId = UUID.v4;
                const expiredDate: Date = new Date();
                expiredDate.setFullYear(expiredDate.getFullYear() + 10);
                document.cookie = `${ OMEGA_ID }=${ omgId }; expires=${ expiredDate }; path=/`;
            }
            Object.assign(this.context, { omgId: omgId });
        }

        // promise 实例单独作为一个变量，是为了尽可能同步执行
        let thisResolve: any;
        const prom = new Promise<void>(resolve => {
            thisResolve = resolve;
        });
        const setOpenIdHandler = tracker.setOpenId;
        tracker.setOpenId = (openid: string): void => {
            setOpenIdHandler.call(tracker, openid);
            if (openid) {
                thisResolve && thisResolve();
            }
        };

        return prom;
    }
}
